import { Button } from "Components/Button";
import TextInput from "Components/TextInput";
import TwoColumnInput from "Components/TwoColumnInput";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import KeyboardHint from "Components/KeyboardHint";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import styles from "Styles/NamePage/NameFormContent.module.css";

export const NameFormContent = ({
  submitCB = () => {},
  firstName = null,
  lastName = null,
  email = null,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      firstName: firstName || "",
      lastName: lastName || "",
      email: email || "",
    },
  });

  useEffect(() => {
    reset({
      firstName: firstName || "",
      lastName: lastName || "",
      email: email || "",
    });
  }, [firstName, lastName, email, reset]);

  const handleFormSubmit = (data) => {
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead");
    }
    submitCB(data);
  };

  return (
    <InfoContentMotionWrapper>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <TwoColumnInput>
          <TextInput
            id="first-name"
            type="text"
            errorText={errors?.firstName?.message}
            placeholder="名字 / First Name"
            {...register("firstName", {
              required: {
                value: true,
                message: "請填寫必填欄位",
              },
              pattern: {
                value: /.+/,
                message: "Please Check the input",
              },
            })}
          />
          <TextInput
            id="last-name"
            type="text"
            errorText={errors?.lastName?.message}
            placeholder="姓氏 / Last Name"
            {...register("lastName", {
              required: {
                value: true,
                message: "請填寫必填欄位",
              },
              pattern: {
                value: /.+/,
                message: "Please Check the input",
              },
            })}
          />
        </TwoColumnInput>
        <TextInput
          id="email"
          type="email"
          errorText={errors?.email?.message}
          className={styles.emailField}
          placeholder="請填寫正確 Email，以確保可收到行銷診斷分析結果"
          {...register("email", {
            required: {
              value: true,
              message: "請填寫必填欄位",
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "請輸入有效的電子郵件地址",
            },
            validate: (value) => {
              const local = value.split("@")[0];
              if (local.length < 3) return true;

              const allSame = local.split("").every((c) => c === local[0]);
              if (allSame) return "請輸入有效的電子郵件地址";

              if (/^\d+$/.test(local)) {
                const diffs = [...local]
                  .slice(1)
                  .map((c, i) => Number(c) - Number(local[i]));
                if (diffs.every((d) => d === 1) || diffs.every((d) => d === -1))
                  return "請輸入有效的電子郵件地址";
              }

              if (/^[a-zA-Z]+$/.test(local)) {
                const lower = local.toLowerCase();
                const diffs = [...lower]
                  .slice(1)
                  .map((c, i) => c.charCodeAt(0) - lower.charCodeAt(i));
                if (diffs.every((d) => d === 1) || diffs.every((d) => d === -1))
                  return "請輸入有效的電子郵件地址";
              }

              return true;
            },
          })}
        />
        <div style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}>
          <Button marginTop type="action" submit>
            OK
          </Button>
          <KeyboardHint />
        </div>
      </form>
    </InfoContentMotionWrapper>
  );
};
